import React, { useState, useRef, useEffect } from "react";
import ProductoCard from "./productoCard";
import Carrito from "./carrito";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "../../static/css/postLayout.css";
import {buscarBodegaPorPuntoVenta} from "../../service/bodegas/bodegasService";
import {useAuth} from "../../AuthContext";
import {useNavigate} from "react-router-dom";
import {buscarProductoStockServicio} from "../../service/productos/buscarProducto";
import {mensajeErrorPersonalizado} from "../../helpers/mensajesSwalError";

const POSLayout = () => {
    const { verificacionToken, removerLocalStorage } = useAuth();
    const navigate = useNavigate();
    const [productos, setProductos] = useState([]);
    const [carrito, setCarrito] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [tiendaSeleccionada, setTiendaSeleccionada] = useState();
    const [ bodegas, setBodegas] = useState([]);

    const inputBusquedaRef = useRef(null);

    //buscar punto de venta
    const buscarPuntoVenta = async () => {
        const respuesta = await buscarBodegaPorPuntoVenta()
        if (respuesta[0]) {
            setBodegas(respuesta[1]);
            respuesta[1].map((valor) => {
                if(valor.puntoVenta){
                    setTiendaSeleccionada(valor.id)
                }
            })
        } else {
            erroresRespuesta(respuesta[2])
        }
    }

    //buscar Productos
    const buscarProductos = async () => {
        const respuesta = await buscarProductoStockServicio()
        if (respuesta[0]) {
            setProductos(respuesta[1]);
        } else {
            erroresRespuesta(respuesta[2])
        }
    }

    const erroresRespuesta = (status) => {
        if (status === 400) {
            setProductos([]);
        } else if (status === 401) {
            navigate("/expiro-sesion");
        } else if (status === 403) {
            navigate("/no-autorizado");
        } else {
            navigate("/no-encontrado");
        }
    }

    // Focus inicial en buscador
    useEffect(() => {
        verificacionToken('ROLE_DUENO')
        inputBusquedaRef.current?.focus();
        buscarPuntoVenta()
        buscarProductos()
    }, []);

    // Filtrar productos
    const productosFiltrados = productos.filter(
        p =>
            p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
            p.codigo.includes(busqueda)
    );

    // Agregar producto al carrito
    const agregarAlCarrito = producto => {
        setCarrito(prev => {
            const existe = prev.find(p => p.id === producto.id);
            if (existe) {
                return prev.map(p =>
                    p.id === producto.id ? { ...p, cantidad: p.cantidad + 1 } : p
                );
            }
            return [...prev, { ...producto, cantidad: 1 }];
        });
    };

    const reducirDelCarrito = producto => {
        setCarrito(prev => {
            const existe = prev.find(p => p.id === producto.id);
            if (!existe) return prev;
            if (existe.cantidad === 1) return prev.filter(p => p.id !== producto.id);
            return prev.map(p =>
                p.id === producto.id ? { ...p, cantidad: p.cantidad - 1 } : p
            );
        });
    };

    const agregarPorCodigo = codigo => {
        const producto = productos.find(p => p.codigo === codigo);
        if (!producto) {
            alert("Producto no encontrado");
            return;
        }
        agregarAlCarrito(producto);
    };

    const handleEnterBusqueda = e => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (!busqueda) return;
            const producto = productos.find(
                p =>
                    p.codigo === busqueda ||
                    p.nombre.toLowerCase() === busqueda.toLowerCase()
            );
            if (!producto) {
                alert("Producto no encontrado");
            } else {
                agregarAlCarrito(producto);
                setBusqueda("");
            }
            inputBusquedaRef.current?.focus(); // mantener focus
        }
    };

    // 🔹 Actualizar catálogo de productos
    const actualizarCatalogo = () => {
        // Aquí puedes reemplazar con un fetch desde API real
        const nuevosProductos = Array.from({ length: 1000 }, (_, i) => ({
            id: i + 1,
            nombre: `Producto ${i + 1} (Actualizado)`,
            precio: Math.floor(Math.random() * 5000) + 1000,
            codigo: `${100000 + i}`,
            imagen: "https://via.placeholder.com/150x100",
        }));
        setProductos(nuevosProductos);
        inputBusquedaRef.current?.focus(); // mantener focus
    };

    return (
        <div className="pos-layout">
            <div className="pos-header">
                <h2 className="titulo-pos">🏪 Punto de Venta</h2>
                <Form.Select
                    value={tiendaSeleccionada}
                    onChange={e => {
                        setTiendaSeleccionada(Number(e.target.value));
                        inputBusquedaRef.current?.focus();
                    }}
                    className="tienda-select-header"
                >
                    {bodegas.map(t =>
                        t.puntoVenta ? (
                            <option key={t.id} value={t.id}>
                                {t.nombre}
                            </option>
                        ) : null
                    )}
                </Form.Select>
                <div className="header-actions">
                    <Button
                        variant="light"
                        onClick={() => {
                            actualizarCatalogo();
                            inputBusquedaRef.current?.focus();
                        }}
                        className="btn-actualizar ms-3"
                    >
                        🔄 Actualizar catálogo
                    </Button>
                </div>
            </div>

            <Container fluid className="mt-3">
                <Row className="mb-3">
                    <Col md={12}>
                        <Form.Control
                            type="text"
                            placeholder="Buscar por nombre o código..."
                            value={busqueda}
                            onChange={e => setBusqueda(e.target.value)}
                            ref={inputBusquedaRef}
                            onKeyDown={e => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (!busqueda) return;

                                    // Buscar por código o nombre
                                    const producto = productos.find(
                                        p =>
                                            p.codigo.toLowerCase() === busqueda.toLowerCase() ||
                                            p.nombre.toLowerCase() === busqueda.toLowerCase()
                                    );

                                    if (!producto) {
                                        mensajeErrorPersonalizado("Producto no encontrado")
                                    } else {
                                        // Obtener stock de la bodega seleccionada
                                        const bodega = producto.bodegas?.find(b => b.id === tiendaSeleccionada);
                                        const stockBodega = bodega ? bodega.productos_bodegas.stock : 0;

                                        // Contar cantidad ya agregada
                                        const stockCarrito = carrito?carrito.find(c => c.id === producto.id):0
                                        const stockMaximo = stockCarrito?stockCarrito.cantidad:0
                                        if (Number(stockBodega) === 0) {
                                            mensajeErrorPersonalizado("Producto sin stock en esta bodega");
                                        } else if (stockMaximo >= stockBodega) {
                                            mensajeErrorPersonalizado("No se puede agregar más, stock máximo alcanzado")
                                        } else {
                                            agregarAlCarrito(producto);

                                        }
                                    }
                                    setBusqueda("");
                                    inputBusquedaRef.current?.focus(); // mantener focus
                                }
                            }}
                            autoFocus
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={8}>
                        <Row>
                            {productosFiltrados.length === 0 && (
                                <p className="text-muted ms-3">
                                    No se encontraron productos...
                                </p>
                            )}
                            {productosFiltrados.map(p => (
                                <Col key={p.id} md={4} className="mb-3">
                                    <ProductoCard
                                        producto={p}
                                        cantidad={carrito.find(c => c.id === p.id)?.cantidad || 0}
                                        onAdd={() => agregarAlCarrito(p)}
                                        onRemove={() => reducirDelCarrito(p)}
                                        bodegaId={tiendaSeleccionada}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col md={4}>
                        <Carrito carrito={carrito} setCarrito={setCarrito} />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default POSLayout;